import { AudioCodec } from '../core/player/audio-format';
import { adaptDashRole } from '../core/player/role';
export var PREFERRED_AUDIO_CODECS_ORDERED_ALL = [
    AudioCodec.EC3,
    AudioCodec.MP4A2,
    AudioCodec.MP4A5
];
// Ordered by highest quality first
export var PREFERRED_AUDIO_CODECS_ORDERED_AAC_ONLY = [
    AudioCodec.MP4A2,
    AudioCodec.MP4A5
];
export var PREFERRED_AUDIO_CODECS_HE_AAC_ONLY = [
    AudioCodec.MP4A5
];
export function isBetterAudioTrack(candidate, previous, maxBandwidthBps) {
    var _candidate_bandwidth;
    // Candidate is above the max bandwidth so it cannot be better
    if (maxBandwidthBps && ((_candidate_bandwidth = candidate.bandwidth) !== null && _candidate_bandwidth !== void 0 ? _candidate_bandwidth : 0) > maxBandwidthBps) {
        return false;
    }
    var channelCountDiff = (candidate.channelsCount || 0) - ((previous === null || previous === void 0 ? void 0 : previous.channelsCount) || 0);
    var _candidate_bandwidth1, _previous_bandwidth;
    var bandwidthDifference = ((_candidate_bandwidth1 = candidate.bandwidth) !== null && _candidate_bandwidth1 !== void 0 ? _candidate_bandwidth1 : 0) - ((_previous_bandwidth = previous.bandwidth) !== null && _previous_bandwidth !== void 0 ? _previous_bandwidth : 0);
    var previousCodecRanking = !previous.audioCodec ? -1 : PREFERRED_AUDIO_CODECS_ORDERED_ALL.indexOf(previous.audioCodec);
    var currentCodecRanking = !candidate.audioCodec ? -1 : PREFERRED_AUDIO_CODECS_ORDERED_ALL.indexOf(candidate.audioCodec);
    var sameRankingCodec = previousCodecRanking === currentCodecRanking;
    var betterCodec = previousCodecRanking > currentCodecRanking;
    if (channelCountDiff > 0) {
        return true;
    } else if (channelCountDiff < 0) {
        return false;
    } else if (betterCodec) {
        return true;
    } else if (sameRankingCodec && bandwidthDifference > 0) {
        return true;
    } else {
        return false;
    }
}
export function getBestTrackForBandwidth(tracks, activeAudioTrack, maxBandwidthBps) {
    var _activeAudioTrack_audioRoles;
    if (maxBandwidthBps === undefined) {
        return;
    }
    var activeRole = adaptDashRole((_activeAudioTrack_audioRoles = activeAudioTrack.audioRoles) === null || _activeAudioTrack_audioRoles === void 0 ? void 0 : _activeAudioTrack_audioRoles[0]);
    var lowestBpsVariant = undefined;
    var bestTrack = undefined;
    var isCompatibleWithActive = function(track) {
        var _track_audioRoles;
        return activeRole === adaptDashRole((_track_audioRoles = track.audioRoles) === null || _track_audioRoles === void 0 ? void 0 : _track_audioRoles[0]) && track.language === activeAudioTrack.language;
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tracks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var track = _step.value;
            if (!isCompatibleWithActive(track)) {
                continue;
            }
            if (!lowestBpsVariant || track.bandwidth < lowestBpsVariant.bandwidth) {
                lowestBpsVariant = track;
            }
            // Does not meet cap
            if (track.bandwidth > maxBandwidthBps) {
                continue;
            }
            if (!bestTrack) {
                bestTrack = track;
            }
            if (isBetterAudioTrack(track, bestTrack)) {
                bestTrack = track;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return bestTrack !== null && bestTrack !== void 0 ? bestTrack : lowestBpsVariant;
}

//# sourceMappingURL=audio-utils.js.map